import React from 'react'
import { PayeeDetailsForm } from './PayeeDetailsForm'
import { PayeeDetailsTab } from './PayeeDetailsTab'

export const payeeDetailsRoutes = [
  {
    props: {
      exact: true,
      path: '/bank-eft/:BankEFTID/payee-details',
    },
    component: <PayeeDetailsTab />,
  },
  {
    props: {
      exact: true,
      path: '/bank-eft/:BankEFTID/payee-details/:CreditorAccountID',
    },
    component: <PayeeDetailsForm />,
  },
]

export default payeeDetailsRoutes
